module.exports = __webpack_public_path__ + "assets/img/btn-download-824c8b48.png";